import { render, staticRenderFns } from "./Claudia.vue?vue&type=template&id=ad16059c"
import script from "./Claudia.vue?vue&type=script&lang=js"
export * from "./Claudia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports